import { orderStatus } from '@/constants/orderStatus';
export const iconSize = {
    active: {
        width: 122,
        height: 40,
    },
    related: {
        width: 122,
        height: 26,
    },
    default: {
        width: 122,
        height: 26,
    },
};
/**
 * html 템플릿
 */
const htmlTemplate = {
    /** 이름만 출력 */
    'name-type': (code, name, cssClass) => `<div
        worker-id="${code}"
        data-cy="mk-${code}"
        title="${name} / ${code}"
        class="icon-worker ${cssClass.join(' ')}">
      <div class="worker-icon__pane contents-sub-title-text">
        <span class="name">${name}</span>
      </div><span class="anchor"></span></div>`,
    /** 카운트도 출력 */
    'count-type': (code, name, allocated = 0, pickup = 0, cssClass) => `<div
        worker-id="${code}"
        data-cy="mk-${code}"
        title="${name} / ${code}"
        class="icon-worker ${cssClass.join(' ')}">
      <div class="worker-icon__pane contents-sub-title-text">
        <span class="name">${name}</span>
        <div class="allocated-data-wrapper">
          <div class="allocated-data">
            <span>${allocated}</span>
            <span>${pickup}</span>
          </div>
        </div>
      </div><span class="anchor"></span></div>`,
};
/**
 * 워커 아이콘 생성
 */
export const createIcon = ({ iconType = 'count-type', naver, code, name, allocated, pickup, isActive = false, relatedWeight = 0, isShareWorker = false, attendCode, }) => {
    /** 활성, 연관, 기본 타입 */
    let type = '';
    if (isActive) {
        type = 'active';
    }
    else if (relatedWeight) {
        type = 'related';
    }
    else {
        type = 'default';
    }
    const cssClass = [];
    cssClass.push(type, isShareWorker ? 'share' : attendCode.toLowerCase(), iconType);
    let content = '';
    if (iconType === 'name-type') {
        content = htmlTemplate['name-type'](code, name, cssClass);
    }
    else if (iconType === 'count-type') {
        content = htmlTemplate['count-type'](code, name, allocated, pickup, cssClass);
    }
    return {
        anchor: new naver.maps.Point(0, iconSize[type].height),
        content,
    };
};
/**
 * 워커 아이콘
 */
export default ({ naver, code, name, orderInfo, isActive = false, relatedWeight = 0, isShareWorker = false, attendCode, }) => {
    let allocated = 0;
    let pickup = 0;
    orderInfo.forEach(({ statusCode, }) => {
        if (statusCode === orderStatus.ALLOCATED.code) {
            allocated += 1;
        }
        if (statusCode === orderStatus.PICKUP_FINISHED.code) {
            pickup += 1;
        }
    });
    return {
        isActive,
        relatedWeight,
        ...createIcon({
            iconType: 'count-type',
            naver,
            code,
            name,
            allocated,
            pickup,
            isActive,
            relatedWeight,
            isShareWorker,
            attendCode,
        }),
    };
};
